import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { ITooltipParams } from 'ag-grid-enterprise';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      display: 'flex',
      padding: theme.spacing(1, 1.5),
      alignItems: 'center',
      gap: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.grey[700],
    },
    label: {
      color: theme.palette.common.white,
      fontFamily: 'Inter',
      fontSize: pxToRem(12),
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeightMedium as number,
      lineHeight: pxToRem(16),
    },
  }),
);

const RemittanceGridTooltip = ({ value }: ITooltipParams) => {
  const classes = useStyles();
  if (!value) return null;
  return (
    <div className={classes.tooltip}>
      <span className={classes.label}>{value}</span>
    </div>
  );
};

export default RemittanceGridTooltip;
